export default "__VITE_ASSET__DyMDIbYy__"